import React, { useState } from 'react';
import DoneProspHK from '../../../../../../../dashboard/components/Functions/Hotkeys/DoneProspHK';
import { FinishedProspecting } from '../functions/FinishedProspect'
// import moment from 'moment'
// import firebase from 'firebase/app';

import { CheckCircleIcon, EyeIcon } from '@heroicons/react/outline';
import Default from '../../../../../../../../images/default.png'

const Prospects = ({contacts, setProspectProfile, profile, setInterests}) => {

    // console.log(contacts)
    const [ linkedin, setLinkedin ] = useState('')

    function classNames(...classes) {
        return classes.filter(Boolean).join(' ')
      }

    const setContact = (contact) =>{
        setProspectProfile(contact)
        setLinkedin(contact?.Linkedin)
        //setInterests(contact.ProspectInterest)

        checkExpDate(contact)
            
        // console.log(contact) 
        // console.log("contact", contact)
        // console.log('in set contact')
    }

    const Prospected = (contact, index) =>{
        FinishedProspecting(contact.id, profile)
        // console.log(index)
        var next = index + 1
        // setProspectProfile(contacts[next])
        // setLinkedin(contacts[next].Linkedin)
        if(contacts[next] !== undefined){
            setProspectProfile(contacts[next])
            setLinkedin(contacts[next].Linkedin)
            setInterests(contacts[next].ProspectInterest)
        } else {
            setProspectProfile()
            setLinkedin()
            setInterests()
        }
    }

    function checkExpDate(contact){
        if(contact.contactExp !== ''){
            var dateToday = new Date();
            var startDate = new Date(contact?.contactExp?.starts_at?.year, (contact?.contactExp?.starts_at?.month - 1), contact?.contactExp?.starts_at?.day)
            const diffTime = Math.abs(dateToday - startDate);
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
            
            if(diffDays <= 60){
                var arrInt = contact.ProspectInterest
                var arrAdd =['Just started']
                setInterests(arrInt.concat(arrAdd).reverse())
            }else{
                setInterests(contact.ProspectInterest)
            }
        }else{
            setInterests(contact.ProspectInterest)
        }
    }

    return (
        <div >
            {contacts?.map((contact, index)=>{
                return(
                    <div className="border-b-2 border-gray-200" key={index}>
                    <div
                    key={index}
                    className={classNames(
                        contact?.Linkedin === linkedin ? "bg-blue-100" : "" ,"overflow hover:shadow-md cursor-pointer focus:bg-gray-300"
                    )}
                    onClick={()=> setContact(contact)}
                    >
                        <div className="px-4 py-4 truncate overflow-ellipsis">
                            <div className="flex">
                                {contact?.contactImg?.includes("proxycurl") ?
                                <img src={Default} alt="pros" className="h-12 rounded-full"/>
                                :
                                <img src={contact?.contactImg} alt="pros" className="h-12 rounded-full"/>
                                }
                                <div className="ml-3">
                                <p 
                                style={{
                                    fontWeight: 700,
                                    fontSize: 15,
                                    marginBottom: '2px',
                                }}
                                >
                                    {contact?.ProspectName}
                                </p>
                                <p className="text-sm text-gray-500 truncate">
                                {contact?.ProspectCompany} 
                                </p>
                                </div>
                            </div>
                        </div>  
                    </div>
                    <div className="flex">
                        <div
                        className="flex p-1 border-2 cursor-pointer border-blue-500 bg-blue-500 hover:bg-blue-400 text-white focus:outline-none w-1/2 text-center w-1/2 text-center"
                        onClick={()=> setContact(contact)}
                        >
                            <EyeIcon className="h-4 mr-1" style={{marginTop: 1}}/><span className="-mt-0.5">View </span>    
                        </div>
                        <div
                        className="flex p-1 border-2 cursor-pointer border-green-500 bg-green-500 hover:bg-green-400 text-white focus:outline-none w-1/2 text-center"
                        onClick={() => Prospected(
                            contact,
                            index
                        )}
                        >
                            <CheckCircleIcon className="h-4 mr-1" style={{marginTop: 1}}/><span className="-mt-0.5">Done</span>
                        </div>
                        <DoneProspHK 
                        doneProsp={() => Prospected(
                            contact,
                            index
                        )}
                        />
                    </div>
                    </div>
                )
            })}
            
        </div>
    )
}

export default Prospects
